// import { Divider } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Card, Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Radio, styled, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
// import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
// import { useMaterialUIController, setShowError, setErrorMessage } from "context";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckedListView from "sohum/components/CheckedListView";
import { getBrands, getCatSubCat, getData } from "utils/FilterStatic";

let catSubCatData = [];
function CIFilter() {
  const reduxState = useSelector((state) => state);
  const [controller,] = useMaterialUIController();
  const { brandName } = controller;

  const dispatch = useDispatch();
  // const [openList, setOpenList] = useState({ Silos: true });
  const [filter, setFilter] = useState([]);

  const [silos, setSilos] = useState([0]);
  const [brands, setBrand] = useState([0]);
  const [category, setCategory] = useState([0]);
  const [subCategory, setSubCategory] = useState([0]);
  const [department, setDepartment] = useState([0]);
  const [type, setType] = useState([0]);
  const [classification, setClassification] = useState([0]);
  const [price, setPrice] = useState([0]);
  const [year, setYear] = useState([0]);
  const [checkedSilos, setCheckedSilos] = useState(reduxState.silos);
  const [checkedDept, setCheckedDept] = useState(reduxState.department);
  const [checkedType, setCheckedType] = useState(reduxState.miscType);
  const [checkedPrice, setCheckedPrice] = useState(reduxState.price);
  const [checkedClassi, setCheckedClassi] = useState(reduxState.classification);
  const [checkedBrands, setCheckedBrand] = useState(reduxState.brands);
  const [checkedCat, setCheckedCat] = useState(reduxState.category);
  const [checkedSubCat, setCheckedSubCat] = useState(reduxState.subCategory);
  const [checkedYear, setCheckedYear] = useState(reduxState.year);

  const setCatSubCat = () => {
    const data = getCatSubCat(catSubCatData, checkedDept, checkedType);
    // console.log(data);
    let catData = getData(data, "c");
    catData = [...new Set(catData.map((item) => item))];
    let subCatData = [];
    if (data !== undefined) {
      data.forEach((element) => {
        if (catData.includes(element.c)) subCatData.push(element.s);
      });
    }
    subCatData = [...new Set(subCatData.map((item) => item))];
    subCatData.sort();
    catData.sort();

    setCategory(catData);
    setCheckedCat(catData);

    setSubCategory(subCatData);
    setCheckedSubCat(subCatData);

    const dt = { cat: catData, sub: subCatData };
    return dt;
  };
  useEffect(() => {
    // const { filterName, savedFilters } = reduxState;

    const { defaultFilter } = reduxState;
    try {
      setFilter(defaultFilter);
      const sl = defaultFilter.filter((item) => item.title === "Silos");
      const dep = defaultFilter.filter((item) => item.title === "Department");
      const ty = defaultFilter.filter((item) => item.title === "Type");
      const pr = defaultFilter.filter((item) => item.title === "Price");
      const cl = defaultFilter.filter((item) => item.title === "Classification");
      const yr = defaultFilter.filter((item) => item.title === "Year");
      const catSub = defaultFilter.filter((item) => item.title === "Category-Sub Category");
      setSilos(getData(sl[0].data, "title"));
      setDepartment(getData(dep[0].data, "title"));
      setType(getData(ty[0].data, "title"));
      setPrice(getData(pr[0].data, "title"));
      setClassification(getData(cl[0].data, "title"));
      setYear(yr[0].data);
      const [tmp] = catSub;
      catSubCatData = tmp;


      // //  register to detect page refresf
      // window.addEventListener("beforeunload", onPageRefresh);
      // // return () => {
      // //   window.removeEventListener("beforeunload", onPageRefresh);
      // // };
    } catch (exception) {
      // console.log("Error in Filter.js");
      // console.log(exception);
    }
  }, [reduxState]);
  useEffect(() => {
    if (filter && filter.length > 0) setBrand(getBrands(reduxState.silos, filter));
  }, [filter]);
  useEffect(() => {
    setCatSubCat();
  }, [checkedDept, checkedType]);
  useEffect(() => {
    const data = getCatSubCat(catSubCatData, checkedDept, checkedType);
    // console.log(data);
    let subCatData = [];
    if (data !== undefined) {
      data.forEach((element) => {
        if (checkedCat.includes(element.c)) subCatData.push(element.s);
      });
    }
    subCatData = [...new Set(subCatData.map((item) => item))];
    subCatData.sort();
    setSubCategory(subCatData);
    setCheckedSubCat(subCatData);
  }, [checkedCat]);
  useEffect(() => {
    if (filter.length === 0) return;
    const br = getBrands(checkedSilos, filter);
    setBrand(br);
    setCheckedBrand(br);
  }, [checkedSilos]);
  const toggleValue = (value, arr) => {
    const currentIndex = arr.indexOf(value);
    const newChecked = [...arr];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    return newChecked;
  };
  const handleToggle = (title, value) => {
    if (title === "Silos") setCheckedSilos(toggleValue(value, checkedSilos));
    else if (title === "Brands") setCheckedBrand(toggleValue(value, checkedBrands));
    else if (title === "Department") setCheckedDept(toggleValue(value, checkedDept));
    else if (title === "Type") setCheckedType(toggleValue(value, checkedType));
    else if (title === "Price") setCheckedPrice(toggleValue(value, checkedPrice));
    else if (title === "Classification") setCheckedClassi(toggleValue(value, checkedClassi));
    else if (title === "Year") setCheckedYear(toggleValue(value, checkedYear));
    else if (title === "Category") setCheckedCat(toggleValue(value, checkedCat));
    else if (title === "Sub Category") setCheckedSubCat(toggleValue(value, checkedSubCat));
  };
  const handleSelectAll = (event, title) => {
    console.log("handleSelectAll");
    const { checked } = event.target;
    if (title === "Silos") {
      if (checked) setCheckedSilos(silos);
      else setCheckedSilos([]);
    } else if (title === "Brands") {
      if (checked) setCheckedBrand(brands);
      else setCheckedBrand([]);
    } else if (title === "Department") {
      if (checked) setCheckedDept(department);
      else setCheckedDept([]);
    } else if (title === "Type") {
      if (checked) setCheckedType(type);
      else setCheckedType([]);
    } else if (title === "Price") {
      if (checked) setCheckedPrice(price);
      else setCheckedPrice([]);
    } else if (title === "Classification") {
      if (checked) setCheckedClassi(classification);
      else setCheckedClassi([]);
    } else if (title === "Year") {
      if (checked) setCheckedYear(year);
      else setCheckedYear([]);
    } else if (title === "Category") {
      if (checked) setCheckedCat(category);
      else setCheckedCat([]);
    } else if (title === "Sub Category") {
      if (checked) setCheckedSubCat(subCategory);
      else setCheckedSubCat([]);
    }
  };
  const applyFilter = () => {
    // check validation
    let br = checkedBrands;
    if (checkedSilos.length === 0) {
      br = getBrands(checkedSilos, filter);
      setBrand(br);
      setCheckedBrand(br);
    }
    if (checkedBrands.length === 0) {
      br = getBrands(checkedSilos, filter);
      setCheckedBrand(br);
    }

    let cat = checkedCat;
    let sub = checkedSubCat;
    if (checkedCat.length === 0) {
      const dt = setCatSubCat();
      cat = dt.cat;
      sub = dt.sub;
    }
    const filters = {
      isRetailer: "No",
      silos: checkedSilos,
      department: checkedDept,
      miscType: checkedType,
      price: checkedPrice,
      classification: checkedClassi,
      brands: br,
      category: cat,
      subCategory: sub,
      year: checkedYear,
    };
    console.log(filters);
    dispatch({ type: "SET_TOP_FILTER", filter: filters });
  };
  const clearFilter = () => {
    setCheckedSilos(reduxState.silosDef);

    const brands = reduxState.brandsDef.sort();
    let tmp = brands.slice(0, 5);
    if (!tmp.includes(brandName)) {
      tmp = brands.slice(0, 4)
      tmp.push(brandName);
    }
    setBrand(reduxState.brandsDef);
    setCheckedBrand(tmp);

    let checkedDepartment = ["Women"];
    if (brandName === "True Classic")
      checkedDepartment = ["Men"];
    
    setCheckedDept(checkedDepartment);
    setCheckedType(reduxState.typeDef);
    setCheckedPrice(reduxState.priceDef);
    setCheckedClassi(reduxState.classificationDef);

    
    setCheckedYear(reduxState.yearDef);
    setCategory(reduxState.categoryDef);
    setCheckedCat(reduxState.categoryDef);
    setSubCategory(reduxState.subCategoryDef);
    setCheckedSubCat(reduxState.subCategoryDef);
  };
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
      }}
    >
      <div
        style={{
          flexGrow: "1",
          overflow: "auto",
        }}
      >
        {/* <CheckedListView
          title="Silos"
          listData={silos}
          checked={checkedSilos}
          handleToggle={handleToggle}
          handleSelectAll={handleSelectAll}
        /> */}

        <CheckedListView
          title="Brands"
          listData={brands}
          checked={checkedBrands}
          handleToggle={handleToggle}
          handleSelectAll={handleSelectAll}
        />
        <CheckedListView
          title="Department"
          listData={department}
          checked={checkedDept}
          handleToggle={handleToggle}
          handleSelectAll={handleSelectAll}
        />
        <CheckedListView
          title="Type"
          listData={type}
          checked={checkedType}
          handleToggle={handleToggle}
          handleSelectAll={handleSelectAll}
        />
        <CheckedListView
          title="Price"
          listData={price}
          checked={checkedPrice}
          handleToggle={handleToggle}
          handleSelectAll={handleSelectAll}
        />
        <CheckedListView
          title="Classification"
          listData={classification}
          checked={checkedClassi}
          handleToggle={handleToggle}
          handleSelectAll={handleSelectAll}
        />
        <CheckedListView
          title="Year"
          listData={year}
          checked={checkedYear}
          handleToggle={handleToggle}
          handleSelectAll={handleSelectAll}
        />
        <CheckedListView
          title="Category"
          listData={category}
          checked={checkedCat}
          handleToggle={handleToggle}
          handleSelectAll={handleSelectAll}
        />
        <CheckedListView
          title="Sub Category"
          listData={subCategory}
          checked={checkedSubCat}
          handleToggle={handleToggle}
          handleSelectAll={handleSelectAll}
        />
      </div>
      <div style={{ flexShrink: "0" }}>
        <Grid container spacing={1} pt={2} pb={2}>
          <Grid item ms={6}>
            <MDButton variant="gradient" fullWidth color="info" onClick={applyFilter}>
              Apply
            </MDButton>
          </Grid>
          <Grid item ms={6}>
            <MDButton variant="outlined" fullWidth color="info" onClick={clearFilter}>
              Clear
            </MDButton>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default CIFilter;
